import { Component, OnInit, OnDestroy } from '@angular/core';
import { Workprocess } from '../workprocess';
import { WorkprocessService } from '../workprocess.service';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { ExplanationService } from '../../explanation.service';
import { environment } from 'environments/environment';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { StateService } from 'app/state.service';
import { AssessmentCriteria } from '../assessment-criteria';

@Component({
  selector: 'app-workprocess',
  templateUrl: './workprocess.component.html',
  styleUrls: ['./workprocess.component.scss']
})
export class WorkprocessComponent implements OnInit, OnDestroy {
  private workprocess$: Subscription;
  private workProcessErrorSubscription: Subscription;
  public workprocess: Workprocess;
  private examinationId: string = null;
  private workprocessCode: string = null;
  public explanationForm: FormGroup = null;

  constructor(private workprocessService: WorkprocessService, private route: ActivatedRoute, private router: Router,
    private explanationService: ExplanationService, private snackbar: SemsoSnackbarService,
    private fb: FormBuilder, private stateService: StateService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.examinationId = params.examinationId;
      this.workprocessCode = params.workprocessId;
      this.getWorkProces();
      this.explanationService.setExplanationSourceUrl(`${environment.api}/kerntaken/${this.examinationId}/pdf/leeg`)
    });

    this.workProcessErrorSubscription = this.workprocessService.workprocessError$.subscribe(data => {
      this.snackbar.error('Fout bij het ophalen van de beoordelingsinformatie');
    });
  }

  private getWorkProces() {
    this.workprocess$ = this.workprocessService
      .getWorkProcessByCreboIdAndWorkprocessCode(this.examinationId, this.workprocessCode).subscribe(data => {
        this.workprocess = data;
        this.explanationForm = this.fb.group({
          explanation: [this.workprocess.opmerkingen]
        });
      });
  }

  public updated(event: boolean) {
    if (event === true) {
      this.getWorkProces();
    }
  }

  public explanationUpdated() {
    this.workprocessService.postExplanation(this.examinationId, this.workprocessCode, this.workprocess.opmerkingen).subscribe();
    this.workprocessDone();
  }

  public workprocessDone() {

    if (!this.workprocess) {
      return false;
    }
    let done = this.checkIfValidForNextStep();

    this.stateService.workprocessDone(this.route.snapshot.url[this.route.snapshot.url.length - 1].path, done);

    if (done) {
      done = this.IfNextIsResultCheckAllValid();
    }

    return done;
  }

  public checkIfValidForNextStep() {
    return this.IfNotAchievedIsCommentFilled() && this.IsAllGradesValid();
  }

  private IfNotAchievedIsCommentFilled() {
    if (this.workprocess.resultaatWerkproces === "Nee" &&
      (this.workprocess.opmerkingen === undefined || this.workprocess.opmerkingen.trim() === '')) {
      return false;
    }
    return true;
  }

  private IfNextIsResultCheckAllValid() {
    const next = this.stateService.getNextRoute(this.route.snapshot.url[this.route.snapshot.url.length - 1].path);

    if (next === 'results') {
      return this.stateService.allStepsAreDone();
    }
    return true;
  }

  private IsAllGradesValid() {
    let waardeValid = true;
    this.workprocess.beoordelingsvorm.forEach(bv => {
      if (bv.waarde !== '-1' && bv.waarde === '') {
        waardeValid = false;
      }
    });

    return waardeValid;
  }

  public resultsIsAllowed() {
    const next = this.stateService.getNextRoute(this.route.snapshot.url[this.route.snapshot.url.length - 1].path);

    if (next === 'results') {
      return this.stateService.allStepsAreDone();
    }

    return true;
  }

  public goToNextStep() {
    const next = this.stateService.getNextRoute(this.route.snapshot.url[this.route.snapshot.url.length - 1].path);

    if (next === 'results') {
      this.router.navigate(['../../', 'result'], { relativeTo: this.route, queryParamsHandling: 'merge' });
    } else {
      this.router.navigate(['../', next], { relativeTo: this.route, queryParamsHandling: 'merge' });
    }
  }

  identifyAssesment(index: number, item: AssessmentCriteria) {
    return item.id;
  }

  ngOnDestroy(): void {
    this.workprocess$.unsubscribe();
    this.workProcessErrorSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/workprocess/workprocess.component.ts